module.exports = __webpack_public_path__ + "img/html-email.13cd9bf.png";